
export enum ExceptionLocationTypeCd {
	DISTRICT = 'District',
	HSS_REGION = 'HSSRegion',
	LINEHAUL_REGION = 'LinehaulRegion',
	LINEHAUL_SIC = 'LinehaulSIC',
	OPERATIONAL_REGION = 'OperationalRegion',
	OPERATION_SIC = 'OperationSIC'}

